import React, { useState, useEffect } from 'react';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Styles from './styles';

function BackToTopButton() {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    const scrollPosition = document.documentElement.scrollTop;

    setShowButton(scrollPosition >= 1.5 * window.innerHeight);
  };

  const handleButtonClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      {showButton && (
        <Fab
          sx={{ ...Styles.common, ...Styles.primary }}
          color="primary"
          size="medium"
          onClick={handleButtonClick}
          aria-label="Back to top"
          id="back-to-top-button"
        >
          <KeyboardArrowUpIcon color="primary" />
        </Fab>
      )}
    </div>
  );
}

export default BackToTopButton;
